import { LearningJourneyTeamImportRow } from '@/store/v2/journeys/teamImport';

/** A row of the uploaded CSV as the review tables show it. */
export type JourneyTeamsCsvImportRow = {
  /**
   * Source line of the row. Unique where the email is not: a duplicate appears twice, and two
   * table rows with the same key would collide.
   */
  key: string;
  email: string;
  /** Team named in the file. Empty on a row whose team cell was blank. */
  teamName: string;
};

/** Row shown in the download of everything that stands between the admin and set-up. */
export type JourneyTeamsCsvImportBlockingRow = {
  key: string;
  email: string;
  teamName: string;
  /** Why the row needs attention, in the admin's words. */
  reason: string;
};

export const toJourneyTeamsCsvImportRow = ({
  email,
  teamName,
  sourceLine,
}: LearningJourneyTeamImportRow): JourneyTeamsCsvImportRow => ({
  key: String(sourceLine),
  email,
  teamName,
});
